const HttpBackend = require('i18next-http-backend/cjs')
const path = require('path')
const { generateLocalePathFromAssetPrefix } = require('./generate-locale-prefix.js')

const isDevelopment =
  process.env.NODE_ENV === 'development' ||
  process.env.ENV_NAME === 'local' ||
  process.env.CI === 'true'

const isServer = typeof window === 'undefined'

module.exports = {
  i18n: {
    defaultLocale: 'en',
    localeDetection: false,
    locales: ['en', 'fr'],
  },
  fallbackLng: {
    default: ['en'],
    fr: ['fr'],
  },
  localePath: isServer ? require('path').resolve('./public/locales') : '/locales',
  localeStructure: '{{lng}}-CA/{{ns}}',
  use: isServer || isDevelopment ? [] : [HttpBackend], // only use HttpBackend on production & integration client
  backend: {
    loadPath: (lng, ns) => {
      if (isServer) {
        // Server-side context
        // Always resolve to a local file system path for the server
        return path.resolve(`./public/locales/${lng}-CA/${ns}.json`)
      } else {
        // Client-side context
        // This path will be used by HttpBackend on the production client
        return generateLocalePathFromAssetPrefix(process.env.ASSET_PREFIX, lng, ns)
      }
    },
    requestOptions: {
      cache: 'default',
      mode: 'cors',
    },
  },
  ns: [
    '404',
    'autocanada',
    'common',
    'cpo',
    'favourites',
    'forgot_password',
    'global_footer',
    'global_header',
    'home',
    'landing_page',
    'listing',
    'login',
    'mobile_link',
    'paidFeatures',
    'payment_estimator',
    'profile',
    'r2s',
    'register',
    'reset_password',
    'routes',
    'srp',
    'trade_in',
    'user_verification',
    'vip',
    'request_viewing',
    'account_settings',
  ],
  preload: ['en', 'fr'],
  react: {
    useSuspense: false,
  },
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  serializeConfig: false,
}
